import { https } from 'shared/utils/https';
import {
  IPersonDetailsDTO,
  IPersonParamsDTO,
  IUserDetailRequestDTO,
  IUserDetailResponseDTO,
  IUserListResponseDTO,
  IUserParamsDTO,
} from './users.dto';

const userEntitiesBaseURL = '/v1';

export const usersData = {
  getUserList: async (params: IUserParamsDTO): Promise<IUserListResponseDTO> => {
    const url = `${userEntitiesBaseURL}/users`;
    const { data } = await https.get<IUserListResponseDTO>(url, { params });
    return data;
  },
  getUserDetail: async (id: number): Promise<IUserDetailResponseDTO> => {
    const url = `${userEntitiesBaseURL}/users/${id}`;
    const { data } = await https.get<IUserDetailResponseDTO>(url);
    return data;
  },
  updateUser: async ({ id, ...rest }: IUserDetailRequestDTO): Promise<void> => {
    const url = `${userEntitiesBaseURL}/users/${id}`;
    await https.patch(url, { ...rest });
  },
  getUser: async (params: IPersonParamsDTO): Promise<IPersonDetailsDTO> => {
    const url = `${userEntitiesBaseURL}/persons`;
    const { data } = await https.get<IPersonDetailsDTO>(url, { params });
    return data;
  },
  activateUser: async (body: IUserDetailRequestDTO): Promise<IPersonDetailsDTO> => {
    const url = `${userEntitiesBaseURL}/users/activate`;
    const { data } = await https.post(url, body);
    return data;
  },
  resetPassword: async (id: number): Promise<void> => {
    const url = `${userEntitiesBaseURL}/users/${id}`;
    await https.patch(url, { shouldResetPassword: true });
  },
};
